import joinClassNames from "../../common/JoinClassNames";
import direction from './TableSorterDirection';
import sortType from './TableSorterSortType';

export default class TableSorter {

	/**
	 *
	 * @param tableSorterInformation the current sorting column's sorter information for field sort priority
	 * @param defaultSortDirection use TableSorterDirection... constants; what direction to start with
	 */
	constructor(tableSorterInformation, defaultSortDirection) {
		// current sorting information
		this.tableSorterInformation = tableSorterInformation;

		// ascending vs descending (use DIRECTION_... constants)
		this.sortDirection = false;
		this.defaultSortDirection = defaultSortDirection;
		// prime the pump
		this.toggleSort(tableSorterInformation);
	}

	hasFields() {
		return this.tableSorterInformation.fields && this.tableSorterInformation.fields.length;
	}

	/**
	 * if field is the same as it was before then sort in the opposite direction
	 *
	 * @param tableSorterInformation TableSorterInformation information about how to sort
	 */
	toggleSort(tableSorterInformation) {
		if (this.tableSorterInformation && this.tableSorterInformation.equals(tableSorterInformation)) {
			if (this.sortDirection) {
				this.sortDirection = this.sortDirection === TableSorter.DIRECTION.ASCENDING ? TableSorter.DIRECTION.DESCENDING : TableSorter.DIRECTION.ASCENDING;
			} else {

				this.sortDirection = this.defaultSortDirection || ((this.hasFields() && this.tableSorterInformation.fields[0].direction) ? this.tableSorterInformation.fields[0].direction : TableSorter.DIRECTION.ASCENDING);
			}
		} else {
			this.tableSorterInformation = tableSorterInformation;
			this.sortDirection = (this.hasFields() && this.tableSorterInformation.fields[0].direction) ? this.tableSorterInformation.fields[0].direction : TableSorter.DIRECTION.ASCENDING;
		}
	}

	sort(data) {
		if (this.tableSorterInformation) {
			data && data.sort && data.sort((a, b) => this.tableSorterInformation.compare(a, b, this.sortDirection, this));
		} else {
			console.error('TableSorter.tableSorterInformation is falsey. Make sure to set a default one when creating the table sorter');
		}
	}

	/**
	 * what is the css class for this th?
	 * if the th's tableSorterInformation matches the current sort then sortAscending/sortDescending
	 *
	 * @param tableSorterInformation the column's information about how it sorts; used to compare if this is the current column being sorted
	 */
	headerRowClass(tableSorterInformation) {
		const classNames = [];
		// this.tableSorterInformation is the current method of how the table is being sorted and can be undefined
		// the tableSorterInformation parameter is then how the column sorts and not how it currently is being sorted
		if (this.tableSorterInformation && this.tableSorterInformation.equals(tableSorterInformation)) {
			classNames.push(this.sortDirection === TableSorter.DIRECTION.ASCENDING ? 'sortAscending headerSortUp' : 'sortDescending headerSortDown');
		}

		// if the column header has sorting information then give it the sortable class
		if (tableSorterInformation) {
			classNames.push('sortable');
		}

		return joinClassNames(...classNames);
	}
}
// types of sorting
TableSorter.SORT = sortType;

// direction of sort
TableSorter.DIRECTION = direction;
